import React from 'react';
import './DiarySection.css';

const DiarySection = () => {
  const diaryPosts = [
    {
      id: 1,
      date: "Feb 10, 2026",
      content: "Exploring the observability layer of Microsoft Fabric to understand how workloads behave at scale. The deeper I dive into usage metrics, performance signals, and capacity patterns, the more valuable it becomes for cost optimization and governance.",
      image: null
    },
  ];

  return (
    <section className="diary-section section">
      <div className="section-container">
        <h2 className="section-heading-main">Digital Diary</h2>
        
        <div className="diary-description">
          <p>Thoughts, reflections, and learnings from my journey in data science.</p>
        </div>

        <div className="diary-feed">
          {diaryPosts.map((post) => (
            <article key={post.id} className="diary-post">
              <div className="diary-post-header">
                <time className="diary-post-date">{post.date}</time>
              </div>
              
              <div className="diary-post-content">
                <p className="diary-post-text">{post.content}</p>
                {post.image && (
                  <div className="diary-post-image">
                    <img src={post.image} alt="Diary post" />
                  </div>
                )}
              </div>
            </article>
          ))}
        </div>

      </div>
    </section>
  );
};

export default DiarySection;
